export default "__VITE_ASSET__CMYgsqp7__"